<template>
  <div id="dashboard">
    <div class="block block-rounded">
      <!-- <div class="block-header block-header-default">
        <h3 class="block-title">白名单车棚用户</h3>
        <div class="block-options">
          <button
            v-if="addBtn"
            type="button"
            class="btn-block-option add-btn mr-2"
            data-toggle="modal"
            @click="create(true, {})"
          >
            <i class="fa fa-plus mr-1"></i> 新增
          </button>
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>-->
      <div class="block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn_carport"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <p class="show-on-print print-title">白名单用户</p>
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          @click="getList('ID',$event)"
                          style="width: 60px; min-width:60px"
                        >#</th>
                        <th
                          class="text-left sorting"
                          @click="getList('USER_ID',$event)"
                          style="min-width:110px;"
                        >用户类型</th>
                        <th
                          class="text-left sorting"
                          @click="getList('USER_ID',$event)"
                          style="min-width:100px;"
                        >用户ID</th>
                        <th
                          class="text-left sorting"
                          @click="getList('MOBILE_PHONE',$event)"
                          style="min-width:100px;"
                        >手机号码</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CARD_NO',$event)"
                          style="min-width:100px;"
                        >实体卡号</th>
                        <th
                          class="text-left sorting"
                          @click="getList('CARPORT_NAME',$event)"
                          style="min-width:100px;"
                        >车棚名称</th>
                        <!-- <th
                          class="text-left sorting"
                          @click="getList('MODEL_TYPE',$event)"
                          style="min-width:100px;"
                        >白名单类型</th>-->

                        <th
                          class="text-left sorting d-md-table-cell"
                          @click="getList('START_TIME',$event)"
                          style="min-width:120px;"
                        >生效日期</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('END_TIME',$event)"
                          style="min-width:120px;"
                        >失效日期</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('REMARK',$event)"
                          style="min-width:110px;"
                        >备注</th>
                        <th
                          class="text-left sorting d-xl-table-cell"
                          @click="getList('STATE',$event)"
                          style="min-width:110px;"
                        >白名单状态</th>
                        <!-- <th
                          class="text-center d-xl-table-cell sorting"
                          style="width: 100px; min-width:100px"
                          @click="getList('USER_STATE',$event)"
                        >用户状态</th>-->
                        <th
                          class="text-center no-print"
                          style="width: 100px;min-width: 100px;"
                          v-if="editBtn||delBtn"
                        >操作</th>
                      </tr>
                    </thead>
                    <tbody v-if="agents.length">
                      <tr v-for="(agent, i) in agents" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left">白名单</td>
                        <td class="text-left">{{ agent.USER_ID }}</td>
                        <td class="text-left">{{ agent.MOBILE_PHONE }}</td>
                        <td class="text-left">{{agent.CARD_NO}}</td>
                        <td class="text-left">{{ agent.CARPORT_NAME }}</td>
                        <!-- <td class="text-left">{{showType(agent.MODEL_TYPE)}}</td> -->

                        <td class="text-left d-md-table-cell">{{ agent.START_TIME }}</td>
                        <td class="text-left">{{agent.END_TIME}}</td>
                        <td class="text-left">{{agent.REMARK}}</td>
                        <td class="text-center">
                          <span
                            class="badge badge-pill"
                            :class="{'badge-success':agent.STATE=='1','badge-secondary':agent.STATE=='0','badge-warning':agent.STATE=='2'}"
                          >{{showEffictive(agent.STATE)}}</span>
                        </td>
                        <!-- <td class="text-center">
                          <div class="custom-control custom-switch custom-control-primary">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              name="example-sw-primary2"
                              :checked="agent.USER_STATE == 0 ? false : true"
                              disabled
                            />
                            <label
                              class="custom-control-label"
                              :for="'dexample-sw-custom-success-state' + agent.ROWNUM"
                            ></label>
                          </div>
                        </td>-->

                        <td class="text-center no-print" v-if="editBtn||delBtn">
                          <div class="btn-group">
                            <!-- <button
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              title="查看"
                              data-original-title="Edit"
                              @click="$router.push({name:'carportWhiteUser', params:{id:agent.USER_ID,val:key,type:'see',white:true}})"
                            >
                              <i class="fa fa-search"></i>
                            </button>-->
                            <button
                              v-if="editBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="modal"
                              title="编辑"
                              @click="$router.push({name:'carportWhiteUser', params:{id:agent.USER_ID,val:key,type:'carport',white:true}})"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </button>
                            <button
                              v-if="delBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"
                              data-toggle="tooltip"
                              title="删除"
                              @click="delUser(agent)"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-times"></i>
                            </button>
                            <!-- <button
                              v-if="stateBtn"
                              type="button"
                              class="btn btn-primary js-tooltip-enabled"  
                              data-toggle="tooltip"
                              title="修改状态"
                              @click="createSet(agent)"
                              data-original-title="Edit"
                            >
                              <i class="fa fa-user-cog"></i>
                            </button>-->
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="11">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="agents && agents.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :small="isMobile"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modal-default-fadein-whiteList"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein-whiteList"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{created ? '新增白名单车棚用户' : '白名单用户信息'}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-1">
            <form class="form-horizontal">
              <div class="form-group" v-show="created">
                <label class="col-sm-12 control-label">
                  新增方式
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select class="form-control" v-model="form.modelType" :disabled="!created">
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in addTypeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group" :class="{'form-group-50':created}">
                <label class="col-sm-12 control-label">
                  用户ID
                  <span class="input-required" v-show="form.modelType == 3">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.userId"
                    :disabled="form.modelType!='3'"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  手机号码
                  <span class="input-required" v-show="form.modelType == 1">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="11"
                    v-model="form.mobile"
                    :disabled="form.modelType!='1'||!created"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  实体卡号
                  <span class="input-required" v-show="form.modelType == 2">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    maxlength="16"
                    v-model="form.cardId"
                    :disabled="form.modelType!='2' && created"
                  />
                </div>
              </div>

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  车棚名称
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <el-select
                    v-model="form.carportId"
                    filterable
                    placeholder="请选择"
                    style="width: 100%;"
                    :disabled="!created"
                  >
                    <el-option
                      v-for="item in carportList"
                      :key="item.CARPORT_ID"
                      :label="item.CARPORT_NAME"
                      :value="item.CARPORT_ID"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <!-- <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  白名单类型
                  <span class="input-required">*</span>
                </label>
                <div class="col-sm-12">
                  <select
                    class="form-control"
                    v-model="form.modelType"
                    @change="changeModelType()"
                    :disabled="!this.created"
                  >
                    <option selected="selected" disabled="disabled" value>请选择</option>
                    <option
                      v-for="(item,index) in typeList"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</option>
                  </select>
                </div>
              </div>-->

              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">
                  白名单生效日期
                  <span class="input-required" v-show="created">*</span>
                </label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white-ab"
                    style="background-color: #fff"
                    v-model="form.startTime"
                  />
                </div>
              </div>
              <div class="form-group form-group-50">
                <label class="col-sm-12 control-label">白名单失效日期</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="js-flatpickr form-control bg-white-ab"
                    style="background-color: #fff"
                    v-model="form.endTime"
                    placeholder="默认无限制"
                  />
                </div>
              </div>
              <!-- <div class="form-group">
                <label class="col-sm-12 control-label">备注</label>
                <div class="col-sm-12">
                  <input type="text" class="form-control" v-model="form.remark" maxlength="16" />
                </div>
              </div>-->
            </form>
          </div>
          <div class="modal-footer modal-footer-right">
            <button type="button" class="btn btn-sm btn-light btn-sm-h" data-dismiss="modal">取消</button>
            <button type="button" class="btn btn-sm btn-primary btn-sm-h" @click="submit()">保存</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Util from "../../../Util.js";
import pageSize from "../../../components/pageSize";
export default {
  name: "index",
  data() {
    return {
      agents: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      wehitUserGroups: [],
      typeList: [
        {
          value: 1,
          label: "按卡号"
        },
        {
          value: 2,
          label: "按用户"
        },
        // {
        //   value: 3,
        //   label: "按rfid"
        // },
        {
          value: 4,
          label: "按用户失效时间"
        }
      ],
      billtype: [
        {
          value: 1,
          label: "免费"
        },
        {
          value: 2,
          label: "按正常收费"
        }
      ],
      allowType: [
        {
          value: 1,
          label: "允许"
        },
        {
          value: 0,
          label: "不允许"
        }
      ],
      addTypeList: [
        {
          value: "3",
          label: "用户ID"
        },
        {
          value: "1",
          label: "手机号码"
        },
        {
          value: "2",
          label: "实体卡号"
        }
      ],
      cityList: [],
      districtList: [],
      cellList: [],
      pro: "",
      city: "",
      dis: "",
      edit: "",
      created: false,
      form: {
        carportId: "",
        modelType: "",
        startTime: "",
        endTime: "",
        modelNo: "",
        remark: "",
        userId: ""
      },
      cardNo: "",
      phone: "",
      clipboard: null,
      sorting: "",
      orderBy: false,
      carportList: [],

      addBtn: Util.isHavePerm("white/addWhiteModel"),
      editBtn:
        Util.isHavePerm("white/addWhiteModel") ||
        Util.isHavePerm("user/updateUserInfo") ||
        Util.isHavePerm("white/deleteWhiteModel"),
      stateBtn: Util.isHavePerm("white/updateWhiteModelState"),
      delBtn: Util.isHavePerm("white/deleteWhiteModel")
    };
  },
  components: {
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    searchKye() {
      return this.$store.state.searchKye;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0 || this.searchKye) {
        this.getList();
      }
    },
    "form.mobile"(val, oldVal) {
      this.form.mobile = Util.isNumber(val);
    },
    "form.cardId"(val, oldVal) {
      this.form.cardId = Util.isNumber(val);
    },
    "form.userId"(val, oldVal) {
      this.form.userId = Util.isNumber(val);
      this.form = Object.assign({}, this.form);
    },
    "form.modelType"(val, oldVal) {
      if (val == "1") {
        this.form.cardId = "";
        this.form.userId = "";
      } else if (val == "2") {
        this.form.mobile = "";
        this.form.userId = "";
      } else if (val == "3") {
        this.form.mobile = "";
        this.form.cardId = "";
      }
    }
  },
  mounted() {
    if (this.params.type && this.params.type == "carport" && this.params.val) {
      this.key = this.searchKye;
    }
    this.getList();
    this.copy();
  },
  methods: {
    changeInput() {
      this.form.userId = Util.isNumber(this.form.userId);
      // 数据改变，视图不改变时，重新编译对象
      this.form = Object.assign({}, this.form);
    },
    showEffictive(str) {
      switch (str) {
        case "0":
          return "失效";
        case "1":
          return "有效";
        // case "2":
        //   return "待生效";
      }
    },
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changeModelType() {
      // if (this.created) {
      if (this.form.modelType == "1") {
        this.form.mobile = "";
      } else if (this.form.modelType == "2") {
        this.form.startTime = "";
        this.form.endTime = "";
        this.form.cardId = "";
      } else if (this.form.modelType == "4") {
        this.form.cardId = "";
      }
      // }
    },
    searchCarport() {
      this.$http.get(`${Util.searchURL}/Carport/ListByAll?key=`).then(
        res => {
          if (res.data.code === 200) {
            this.carportList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    showType(str) {
      switch (str) {
        case "1":
          return "按卡号";
        case "2":
          return "按用户";
        case "3":
          return "按RFID";
        case "4":
          return "按用户失效时间";
      }
    },
    create(bool, item) {
      jQuery("#modal-default-fadein-whiteList").modal("show");
      this.searchCarport();
      if (bool) {
        this.created = true;
        this.cardNo = "";
        this.phone = "";
        this.form = {
          carportId: "",
          modelType: "",
          startTime: "",
          endTime: "",
          modelNo: "",
          remark: "",
          mobile: "",
          cardId: ""
        };
      } else {
        this.created = false;
        this.getDetail(item.ID);
      }
    },
    getDetail(id) {
      this.$http.get(`${Util.searchURL}/Carport/GetWhiteList/${id}`).then(
        res => {
          if (res.data.code === 200) {
            this.phone = "";
            this.cardNo = "";
            let d = res.data.data;
            this.form = {
              id: d.ID,
              CARPORT_NAME: d.CARPORT_NAME,
              carportId: d.CARPORT_ID,
              cellId: d.CELL_ID,
              cellName: d.CELL_NAME,
              modelNo: d.model_no,
              remark: d.REMARK,
              cardId: d.CARD_NO,
              mobile: d.MOBILE_PHONE,
              userId: d.USER_ID,
              startTime:
                (d.START_TIME && new Date(d.START_TIME).Format("yyyy-MM-dd")) ||
                "",
              endTime:
                (d.END_TIME && new Date(d.END_TIME).Format("yyyy-MM-dd")) || ""
            };
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    showModal(id, value) {
      $(`#modify${id}`).click(_ => {
        this.created = false;
        this.form = {
          remark: value.REMARK,
          billingType: value.BILLING_TYPE == "免费" ? 1 : 2,
          groupId: value.GROUP_ID
        };
      });
    },
    submit() {
      let url = "";
      if (this.form.modelType == "1") {
        this.form.modelNo = this.cardNo;
      } else if (this.form.modelType == "2") {
        this.form.modelNo = this.phone;
      } else if (this.form.modelType == "4") {
        this.form.modelNo = "";
        if (this.form.mobile == "") {
          Util.message("err", "请输入手机号");
          return;
        }
        if (this.form.mobile != "" && Util.checkPhone(this.form.mobile)) {
          Util.message("err", "请输入正确手机号");
          return;
        }
        if (this.form.startTime == "") {
          Util.message("err", "请选择生效时间");
          return;
        }
        if (this.form.endTime == "") {
          Util.message("err", "请选择失效时间");
          return;
        }
      }
      if (this.created) {
        url = `${Util.operateURL}/white/addWhiteModel`;
      } else {
        url = `${Util.operateURL}/white/updateWhiteModel `;
      }
      this.$http.post(url, this.form).then(
        res => {
          if (res.data.code === 200) {
            jQuery("#modal-default-fadein-whiteList").modal("hide");
            Util.message("succ", res.data.desc);
            this.getList();
          } else {
            Util.message("err", res.data.desc);
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    delUser(val) {
      swal("确定移除白名单用户？", {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http
              .post(`${Util.operateURL}/white/deleteWhiteModel`, {
                id: val.ID
              })
              .then(res => {
                if (res.data.code === 200) {
                  Util.message("succ", res.data.desc);
                  this.getList();
                } else {
                  Util.message("err", res.data.desc);
                }
              });
            break;
        }
      });
    },
    createSet(val) {
      this.del = val.USER_STATE == 1 ? 0 : 1;
      let text = this.del == 0 ? "确定禁用？" : "确定启用？";
      swal(text, {
        buttons: {
          cancel: {
            text: "取消",
            className: "btn btn-sm btn-light btn-sm-h",
            visible: true
          },
          defeat: {
            text: "确定",
            className: "btn btn-sm btn-primary btn-sm-h"
          }
        }
      }).then(value => {
        switch (value) {
          case "defeat":
            this.$http
              .post(`${Util.operateURL}/white/updateWhiteModelState/${val.ID}`)
              .then(
                res => {
                  if (res.data.code == 200) {
                    Util.message("succ", res.data.desc);
                    this.getList();
                  } else {
                    Util.message("err", res.data.desc);
                  }
                },
                err => {
                  console.log(err);
                }
              );
            break;
        }
      });
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }

      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByWhiteList/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.agents = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    provinceSel() {
      this.$http.get(`${Util.searchURL}/City/ListByProvince/${this.pro}`).then(
        res => {
          if (res.data.code === 200) {
            this.cityList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    citySel() {
      this.$http.get(`${Util.searchURL}/District/ListByCity/${this.city}`).then(
        res => {
          if (res.data.code === 200) {
            this.districtList = res.data.data;
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    disSel() {
      this.$http
        .get(`${Util.searchURL}/FlatComplex/ListByDistrict/${this.dis}`)
        .then(
          res => {
            if (res.data.code === 200) {
              this.cellList = res.data.data;
            }
          },
          err => {
            console.log(err);
          }
        );
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${Util.searchURL}/Carport/ListByWhiteList/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[1].innerText;
      var btn = document.getElementById("copybtn_carport");
      btn.setAttribute("data-clipboard-text", copyStr);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();
        e.clearSelection();
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    }
  }
};
</script>